import "./style.scss";

type Option = {
  id: string;
  label: string;
};

type Props = {
  value: string;
  options: Option[];
  onChange: (value: string) => void;
  onClose: () => void;
};

const DefaultSelector = ({ value, options, onChange, onClose }: Props) => {
  const handleSelect = (optionValue: string) => {
    if (optionValue === value) {
      onClose();
      return;
    }
    onChange(optionValue);
    onClose();
  };

  return (
    <div className="default-selector">
      <ul className="default-selector-ul">
        {options.map(({ id, label }) => (
          <li key={id} onClick={() => handleSelect(label)}>
            <p className={`default-selector-label ${id}`}>{label}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DefaultSelector;
